import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";
import walletOutline from "../../assets/images/sidebar/ticket-star-outline.svg";
import walletOrange from "../../assets/images/sidebar/ticket-star-orange.svg";
import gameOutline from "../../assets/images/sidebar/game-outline.svg";
import gameOrange from "../../assets/images/sidebar/game-orange.svg";
import locationOutline from "../../assets/images/sidebar/location-outline.svg";
import locationOrange from "../../assets/images/sidebar/location-orange.svg";
import settingOutline from "../../assets/images/sidebar/setting-outline.svg";
import settingOrange from "../../assets/images/sidebar/setting-orange.svg";
import communityOutline from "../../assets/images/sidebar/community-outline.svg";
import communityOrange from "../../assets/images/sidebar/community-orange.svg";
import logoutOutline from "../../assets/images/sidebar/logout-outline.svg";
import logoutOrange from "../../assets/images/sidebar/logout-orange.svg";
import supportOutline from "../../assets/images/sidebar/chat-outline.svg";
import supportOrange from "../../assets/images/sidebar/chat-orange.svg";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// Redux
import { connect } from "react-redux";
import { toggleLeftmenu } from "../../store/layout/actions";

// API
import { post } from "../../api/axios";
import endpoints from "../../api/endpoints";

// Utils
import { extractErrorMessage } from "../../utils/errorHandler";

// Toast notifications
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const SidebarContent = (props) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [focusedItem, setFocusedItem] = useState(null);

  // Handle navigation click to close sidebar on tablet devices
  const handleNavClick = () => {
    const windowSize = document.documentElement.clientWidth;
    if (windowSize <= 991) {
      props.toggleLeftmenu(false);
    }
  };

  // Configure toastr options
  toastr.options = {
    positionClass: "toast-bottom-left",
    timeOut: 5000,
    closeButton: true,
    progressBar: true,
  };

  // const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      // scrollElement(item);
      return false;
    }
    // scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  const isActive = (pathname) => {
    return path.pathname === pathname;
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await post(endpoints.logout, {});
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      toastr.success("Logged out successfully!");
      props.router.navigate("/login");
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toastr.error(errorMessage);
    }
  };

  // useEffect(() => {
  //   ref.current.recalculate();
  // }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  // function scrollElement(item) {
  //   if (item) {
  //     const currentPosition = item.offsetTop;
  //     if (currentPosition > window.innerHeight) {
  //       ref.current.getScrollElement().scrollTop = currentPosition - 300;
  //     }
  //   }
  // }
  return (
    <React.Fragment>
      <div className="sidebar-wrapper">
        <SimpleBar style={{ maxHeight: "calc(100% - 120px)" }}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link
                  to="/vouchers"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("vouchers")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("vouchers")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/vouchers") ||
                      hoveredItem === "vouchers" ||
                      focusedItem === "vouchers"
                        ? walletOrange
                        : walletOutline
                    }
                    alt="vouchers"
                  />
                  <span>{props.t("Vouchers")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/referrals"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("referrals")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("referrals")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/referrals") ||
                      hoveredItem === "referrals" ||
                      focusedItem === "referrals"
                        ? communityOrange
                        : communityOutline
                    }
                    alt="community"
                  />
                  <span>{props.t("Referrals")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/games"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("games")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("games")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/games") ||
                      hoveredItem === "games" ||
                      focusedItem === "games"
                        ? gameOrange
                        : gameOutline
                    }
                    alt="game"
                  />
                  <span>{props.t("Games")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurants"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("restaurants")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("restaurants")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/restaurants") ||
                      hoveredItem === "restaurants" ||
                      focusedItem === "restaurants"
                        ? locationOrange
                        : locationOutline
                    }
                    alt="location"
                  />
                  <span>{props.t("Restaurants")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/settings"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("settings")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("settings")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/settings") ||
                      hoveredItem === "settings" ||
                      focusedItem === "settings"
                        ? settingOrange
                        : settingOutline
                    }
                    alt="setting"
                  />
                  <span>{props.t("Settings")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("support")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("support")}
                  onBlur={() => setFocusedItem(null)}
                  onClick={handleNavClick}
                >
                  <img
                    src={
                      isActive("/support") ||
                      hoveredItem === "support" ||
                      focusedItem === "support"
                        ? supportOrange
                        : supportOutline
                    }
                    alt="support"
                  />
                  <span>{props.t("Support")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
        <div className="sidebar-footer">
          <Link
            to="/logout"
            className="sidebar-logout-btn"
            onMouseEnter={() => setHoveredItem("logout")}
            onMouseLeave={() => setHoveredItem(null)}
            onFocus={() => setFocusedItem("logout")}
            onBlur={() => setFocusedItem(null)}
            onClick={handleLogout}
          >
            <img
              src={
                hoveredItem === "logout" || focusedItem === "logout"
                  ? logoutOrange
                  : logoutOutline
              }
              alt="logout"
            />
            <span>{props.t("Logout")}</span>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  toggleLeftmenu: (isopen) => dispatch(toggleLeftmenu(isopen)),
});

export default connect(
  null,
  mapDispatchToProps,
)(withRouter(withTranslation()(SidebarContent)));
